import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import { getDataAtual, getDataFormatada, getData, getDataHoraBanco, getDataHoraFormatada } from '../utils/dataUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'ANIMAL_VACINA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = { datahora_vacina: getDataAtual() }) {
    return [
        initialize('animalVacinaForm', {
			...registro,
			datahora_vacina: getDataHoraFormatada(registro.datahora_vacina, 'DD/MM/YYYY HH:mm')
		})
    ];
}

export function getLista(id_empresa) {
    const request = axios.get(`${consts.API_URL}/animalvacina?id_empresa=${id_empresa}`);
    return {
        type: 'ANIMAL_VACINA_LISTADO',
        payload: request
    };
}

export function getListaGranja(id_empresa) {
    const request = axios.get(`${consts.API_URL}/granja/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'ANIMAL_VACINA_GRANJA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaLote(id_empresa) {
    const request = axios.get(`${consts.API_URL}/lote/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'ANIMAL_VACINA_LOTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaAnimal(id_empresa) {
    const request = axios.get(`${consts.API_URL}/animal/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'ANIMAL_VACINA_ANIMAL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVacina(id_empresa) {
    const request = axios.get(`${consts.API_URL}/produto/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'ANIMAL_VACINA_VACINA_SELECT_LISTADO',
        payload: request
    };
}

export function salvar(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/animalvacina`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa,
			datahora_vacina: getDataHoraBanco(registro.datahora_vacina),
			id_animal: registro.id_animal == 0 ? null : registro.id_animal
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(getState().auth.usuario.id_empresa));
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/animalvacina?id=${registro.id}`)
            .then(resp => {
                setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(getState().auth.usuario.id_empresa));
                dispatch(setModoTela('lista'));
            })
            .catch(e => {
                setErroAPI(e);
            });
    };
}
